module.exports = __webpack_public_path__ + "img/logo.4374fc49.png";